<template>
	<div class="im-routes">
		<div class="im-routes__lable">
			<label>选择品牌：</label>
			<el-select v-model="childBrand" style="width: 300px;" clearable>
				<el-option v-for="(item,index) in subBrandList" :key="index" :value="item.id" :label="item.name"></el-option>
			</el-select>
		</div>
		<section v-loading="loading">
			<!-- <div class="im-routes__desc">
				<span>专属客服：</span>
				<div>
					<el-checkbox v-model="enabledExclusiveAgent" @change="onCheckbox">开启</el-checkbox>
					<p>*开启后，客户如有专属客服，由专属客服接</p>
				</div>
			</div> -->
			<div class="im-routes__ways">
				<span>进线分配方式：</span>
				<ul>
					<li>1. 单一技能客服：轮询分配</li>
					<li>2. 多技能客服：加权轮询分配 <p>*系统按照技能组加权算法，分配同一时间内不同技能组客人进线的比例，权重越高，则分配比例越大</p></li>
				</ul>
			</div>
			<div class="im-routes__set">
				<span>进线优先级设置：</span>
				<el-button type="primary" plain size="mini" icon="el-icon-plus" @click="onAdd">创建优先组</el-button>
				<p>*优先组的客人始终排在普通组前方，优先1级别最高</p>
			</div>
			 <TableBox :rows="item"  v-for="(item, index) in catch_lists" :key="index" @onEdit="onEdit" @getData="getData"></TableBox>
		</section>
		 <!-- 创建优先组 -->
		 <Detail ref="detail" :lists="catch_lists"  @pushCatchList="pushCatchList" @updateCatchList="updateCatchList"/>
	</div>
</template>

<script>
	import { mapGetters } from "vuex";
    import TableBox from './table.vue';
	import Detail from './detail.vue';
	
	export default {
		computed:{
			 ...mapGetters([
				'subBrandList',
			])
		},
		watch: {
			'childBrand':{
				handler(val){
					this.getData()
				}
			}
		},
		components: {
			TableBox,
			Detail
		},
		data() {
			return {
				loading:false,
				enabledExclusiveAgent:false,
				brand:'',
				childBrand:'',
				catch_lists:[],
				
			}
		},
		methods:{
			// 创建优先组
			pushCatchList(data){
				this.catch_lists.push({
					vipGroupName:data.skillName,
					vipGroup:data.vipGroup,
					vipGroupLevel:data.num,
					brand:this.brand,
					childBrand:this.childBrand,
					enabledExclusiveAgent:this.enabledExclusiveAgent,
					id:this.childBrand + this.catch_lists.length,
					skillGroupList:[]
				});
				this.catch_lists.sort((a,b) => a.vipGroupLevel - b.vipGroupLevel);
			},
			//编辑优先组
			updateCatchList(data){
				let index = this.catch_lists.findIndex(el => el.id == data.id);
				this.catch_lists[index].vipGroupName = data.skillName;
				this.catch_lists[index].vipGroupLevel = data.num;
				this.catch_lists[index].skillGroupList.map(item => {
					item.vipGroupLevel = data.num;
					item.vipGroupName = data.skillName;
				})
				let params = {
						brand:this.brand,
						childBrand:this.childBrand,
						enabledExclusiveAgent:this.enabledExclusiveAgent,
						skillGroupList:this.catch_lists[index].skillGroupList,
				}
				this.$api.updateImServiceRouterItem(params).then(res => {
					if(res.errcode == 0){
						this.$message.success('操作成功');
						this.getData('noloading')
					}
				})
			},
			onAdd(){
				this.$refs.detail.onOpen();
			},
			onEdit(data){
				this.$refs.detail.onOpen(data);
			},
			getData(val){
				this.loading = val ? false : true;
				this.$api.getImServiceRouterList(this.childBrand).then(res => {
					this.enabledExclusiveAgent = res.data.enabledExclusiveAgent;
					this.brand = res.data.brand;
					this.catch_lists = this.formatKey(res.data.skillGroupList).sort((a,b) => a.vipGroupLevel - b.vipGroupLevel);
					this.loading = false;
				})
			},
			async onCheckbox(){
				let params = {
						brand:this.brand,
						childBrand:this.childBrand,
						enabledExclusiveAgent:this.enabledExclusiveAgent,
						skillGroupList:[],
				}
				await this.$api.getImServiceRouterList(this.childBrand).then(res => {
					params.skillGroupList = res.data.skillGroupList;
					 this.$api.updateImServiceRouterItem(params).then(res => {
						if(res.errcode == 0){
							this.$message.success('操作成功')
						}
					})
				})	
			},
			formatKey(data){
				let c = [];
				let d = {};
				data.forEach((element, index) => {
					element.vipGroupName = element.vipGroupName || '普通组';
					if (!d[element.vipGroupName]) {
						c.push({
							vipGroupName:element.vipGroupName,
							vipGroup:element.vipGroup,
							vipGroupLevel:element.vipGroupLevel,
							brand:element.brand,
							childBrand:element.childBrand,
							enabledExclusiveAgent:this.enabledExclusiveAgent,
							skillGroupList:[element],
							id:element.childBrand + index
						});
						d[element.vipGroupName] = element;
					} else {
						c.forEach(ele => {
							if (ele.vipGroupName == element.vipGroupName) {
								ele.skillGroupList.push(element);
							}
						});
					}
				
				});
				return c;
			}
		},
		mounted(){
			this.childBrand = this.subBrandList.length > 0 ? this.subBrandList[0].id : '';
		}
	}
</script>

<style lang="scss" scoped>
	.im-routes {
		padding: 0 10px;
		height: 100%;
		overflow: auto;
		&__lable,&__desc,&__ways,&__set {
			color: #3C4353;
			font-size: 14px;
			font-weight: bold;
			p {
				color: #A6AAB8;
			}
		}
		&__desc {
			margin: 30px 0;
			display: flex;
			align-items: center;
			::v-deep.el-checkbox__label {
				color: #566980;
			}
			> div {
				display: flex;
				align-items: center;
				color: #A6AAB8;
				p {
					margin-left: 20px;
					font-weight: normal;
				}
			}
		}
		&__ways {
			margin-top: 30px;
			ul {
				margin-top: 10px;
			}
			li {
				list-style: none;
				font-weight: 400;
				color: #566980;
				margin-top: 6px;
				display: flex;
				align-items: center;
				p {
					margin-left: 10px;
				}
			}
		}
		&__set {
			margin-top: 30px;
			display: flex;
			align-items: center;
			
			p {
				margin-left: 14px;
				font-weight: 400;
			}
		}
	}
</style>
